import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { I18nicDateTimeDirective } from '../directives/i18nic-date-time.directive';
import { I18nicSelectDirective } from '../directives/i18nic-select.directive';

@NgModule({
  declarations: [I18nicDateTimeDirective, I18nicSelectDirective],
  imports: [CommonModule],
  exports: [I18nicDateTimeDirective, I18nicSelectDirective],
})
export class I18nModule {}
